module.exports = __webpack_public_path__ + "img/P527.a9d0316c.jpg";